import {observer} from "mobx-react";
import React from "react";
import {Modal} from "@mui/material";
import {isEqual} from "lodash";
import {
	CloseBtn,
	ModalBody,
	ModalBox,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalText,
	ModalTitle,
} from "views/components/modals/common/common.component";
import {useViewController} from "data/services/locator";
import {IModalsController} from "views/controllers/modals/modals.controller";
import {Bindings} from "data/constants/bindings";
import {ModalType} from "data/enums";
import {ReactComponent as Logo} from "assets/img/gamezone/pinpoint_logo_dark.svg";
import {ReactComponent as IconClose} from "assets/img/icon/close.svg";
import {PrimaryButton} from "views/components/style";
import styled from "@emotion/styled";

const LogoStyled = styled(Logo)`
	max-width: 220px;
`;

const ModalTitleStyled = styled(ModalTitle)`
	margin-top: 8px;
`;

const ModalTextStyled = styled(ModalText)`
	margin-bottom: 13px;
`;

export const WelcomeModal: React.FC = observer(() => {
	const controller = useViewController<IModalsController>(Bindings.ModalsController);
	const {i18n, visibleModal, close, onWelcomeCtaClick} = controller;
	const isVisible = isEqual(visibleModal, ModalType.WELCOME);

	if (!isVisible) {
		return null;
	}

	const title = i18n.t("pinpoint.modal.welcome.title", "Welcome to pinpoint");
	const message = i18n.t(
		"pinpoint.modal.welcome.description",
		"Two games in one! Predict who will hit the Longest Drive and hit Nearest to the Pin for a chance to win daily prizes."
	);

	return (
		<Modal open={isVisible}>
			<ModalBox>
				<ModalContent>
					<ModalHeader>
						<LogoStyled />
					</ModalHeader>
					<ModalBody>
						<ModalTitleStyled>{title}</ModalTitleStyled>
						<ModalTextStyled>{message}</ModalTextStyled>
					</ModalBody>
					<CloseBtn onClick={close}>
						<IconClose />
					</CloseBtn>
					<ModalFooter>
						<PrimaryButton
							fullWidth
							onClick={onWelcomeCtaClick}
							variant="contained"
							size="large">
							{i18n.t("pinpoint.modal.welcome.cta", "Predict now")}
						</PrimaryButton>
					</ModalFooter>
				</ModalContent>
			</ModalBox>
		</Modal>
	);
});
